import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

// Shown in place of a page whose feature isn't in the academy's plan.
export const PlanLockedCard = ({ isAdmin }) => (
  <div className="max-w-lg mx-auto mt-16 bg-white border border-slate-200 rounded-xl p-8 text-center" data-testid="plan-locked-card">
    <div className="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-4">
      <Lock className="w-5 h-5 text-slate-500" />
    </div>
    <h2 className="text-lg font-semibold text-slate-900">Not included in your plan</h2>
    <p className="text-sm text-slate-600 mt-2">
      This area isn&apos;t part of your academy&apos;s current plan.{' '}
      {isAdmin ? 'Upgrade to unlock it.' : 'Please contact your academy administrator.'}
    </p>
    {isAdmin && (
      <Link to="/admin/business-hours?tab=plan-billing" className="inline-block mt-5 px-4 py-2 rounded-md bg-slate-900 text-white text-sm hover:bg-slate-800" data-testid="plan-locked-upgrade">
        Upgrade plan
      </Link>
    )}
  </div>
);

export default PlanLockedCard;
